import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { globals } from '../globals';
import { ModeloDownloadAnexo } from '../models/modelo-download-anexo';
import { GlobalService } from './global.service';

@Injectable({
  providedIn: 'root'
})
export class ModeloDownloadAnexoService {

  constructor(private globalService: GlobalService, private http: HttpClient) {

  }

  consultaModeloDownloadAnexos() {
    return this.http.get<ModeloDownloadAnexo[]>(globals.apiUrl + '/api/ModeloDownloadAnexo/Lista');
  }

  consultarModeloDownloadAnexosComPaginacao(descri: string, paginaAtual, qtdRegistros, campoOrdenacao, orientacaoOrdenacao) {

    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao);

    if (descri.trim() !== '') {
      parametros = parametros.set('descri', descri);
    }

    return this.http.get<any>(globals.apiUrl + '/api/ModeloDownloadAnexo/ListaPag',
      {
        params: parametros
      });
  }

  consultarPorIdModeloDownloadAnexo(id) {
    return this.http.get<any>(globals.apiUrl + '/api/ModeloDownloadAnexo/Buscar',
      { params: new HttpParams().set('id', id) });
  }

  salvar(ModeloDownloadAnexo) {
    return this.http.post(globals.apiUrl + '/api/ModeloDownloadAnexo/Salvar', ModeloDownloadAnexo);
  }

  excluir(id) {
    return this.http.delete(globals.apiUrl + '/api/ModeloDownloadAnexo/Excluir',
      { params: new HttpParams().set('id', id) });
  }
}
